import React, { useEffect, useRef } from 'react';

type BettorVouchProps = {
    VOUCHED_ID?:string,
    VOUCHED_CALLBACK_URL: string,
    VOUCHED_SANDBOX?:boolean,
    first_name: string,
    last_name:string,
    email:string,
    phone:string
}
const BettorVouch = ({ VOUCHED_CALLBACK_URL, first_name, last_name, email, phone }:BettorVouchProps) => {
    const id = 'vouched-container';
    const vouchedRef = useRef();

    useEffect(() => {
        // Assuming vouched is included via script tag or otherwise loaded
        if (!window.Vouched || vouchedRef.current) {
          return;
        }
    
        const instance = window.Vouched({
          // your configuration
          verification: {
            // verify the user's information 
            firstName: first_name,
            lastName: last_name,
            // used for the crosscheck feature
            email: email,
            phone: phone,
            enableIPAddress: true
          },
          id: 'camera',
          face: 'camera',
          showUploadFirst: false,
          //token:player_vouch_token?.token,
          appId: 'Q3tmJ3r9FnkN*n-MqS-!j0NS*k!mdo',
          //appId: "adqEZph8t*_NBFy6u_l4!t~Hin6kpK", //SANDBOX
          // your webhook for POST verification processing
          callbackURL: VOUCHED_CALLBACK_URL,
          sandbox: false,
          // mobile handoff
          crossDevice: true,
          crossDeviceQRCode: true,
          includeBackId: true,
          //includeBarcode:true,
          cameraScreenLabelBackId: 'Please turn ID over to capture back',
          onInit: async() => {
            // If crossDevice is true, a web token is created during initialization 
            // Your backend will save and associate the token the user.
            //fetch(`/yourapi/idv?job_token=${job.token}&&user=${user.id}`);
            //let pvt:PlayerVouchTokenProps = {
            //    player_vouch_token_id:'', player_id:player.player_id, token, create_datetime:'', last_update_datetime:'', status:'active'
            //}
            //await player_saveVouchToken(pvt)
          },
          onCamera: () => {
          },
          onDone: ()=> {
          },
          // theme
          theme: {
            name: 'verbose',
          },
        });

        vouchedRef.current = instance;
    
        instance
          .mount(`#${id}`)
          .then(() => {
          // optionally await mounting, usually not required when using callbacks.
            console.log('vouched mounted');
          });
    
        return () => {
          instance.unmount(`#${id}`);
        };
      }, []);


    return <div style={{ height:'100%' }} id={id} />

    
}

export default BettorVouch


